<template>
<div>

<v-layout d-flex>
<v-card>
<v-toolbar height="42" flat>
<v-toolbar-title> <v-icon   color="#4A76A8" left>mdi-filter</v-icon>  Фильтры </v-toolbar-title>
<v-spacer></v-spacer>
<v-btn @click="init.modals.creator = true" color="#4A76A8"   flat small> <v-icon left>mdi-plus</v-icon>  Создать фильтр</v-btn>
</v-toolbar>

<v-card-text>
<list :init="init" :filter="filter"></list>
</v-card-text>
</v-card>

</v-layout>





<v-dialog  scrollable  persistent  width="900" v-model="init.modals.creator">
<creator :init="init" :filter="filter"></creator>
</v-dialog>


</div>
</template>




<script>
import axios from 'axios'
import creator from './creator.vue'
import list from './list.vue'
export default {
components:{creator,list},
 data: function(){
  return {

init:{
paramsMod:false,
paramsModSelected:'',
isCreator:true,
selectedFilterId: null,
modals:{
creator: false,
},
skList: [],
},


filter:{
name: '',
infoText:'',
selectedType:1,
weight: 0,
types:[{text:'Бот фильтр',value:1},{text:'Исключение',value:2}],
filters: [
{
// Личные данные
isMan:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
isWoman:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
isAgeMore:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:17,
  },
},
isAgeLess:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:16,
  },
},

//приватность
isClosedProfile:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
isOpenProfile:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
isOpenMsg:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
isOpenFriendsReq:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
//Счетчик активности
isFriendsMore:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:0,
  },
},
isFriendsLess:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:1,
  },
},
isFollowersMore:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:0,
  },
},
isFollowersLess:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:1,
  },
},
isFollowMore:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:0,
  },
},
isFollowLess:{
  active:false,
  weight:0,
  params:{
    is:false,
    count:1,
  },
},
// другое
isEngName:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
endsOfLastName:{
  active:false,
  weight:0,
  params:{
    is:true,
    ends:"",
  },
},
isOfflineLots:{
  active:false,
  weight:0,
  params:{
    is:true,
    howOldDays:3,
    howOldHours:0,
    howOldMin:0,
  },
},
isPhotosInOneTime:{
  active:false,
  weight:0,
  params:{
    is:false,
    howOldDays:3,
    howOldHours:0,
    howOldMin:0,
    photoCount:[2,25],
  },
},
isIdBigger:{
  active:false,
  weight:0,
  params:{
    is:false,
    id:500000000,
  },
},
isIdSmaller:{
  active:false,
  weight:0,
  params:{
    is:false,
    id:500000000,
  },
},
isWithoutAva:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
// другое
// другое - подозрительные репосты
isSuspectRepost:{
  active:false,
  weight:0,
  params:{
    is:false,
  },
},
// другое - подозрительный входящий трафик , тем что ids совпадают  работа над таблицей  info_pages
isSuspectTraffIds:{
  active:false,
  weight:0,
  params:{
    is:false,
    intCount:3,
    howMaxMin:40,
    intersectMin:4,
    maxValueOfIntersectsToMidPercen: 10,
    onlyOneSrc:false,
  },
},
// другое - подозрительный подписки - чел подписывается на паблики что созданы в одно и тоже время
isSuspectPublicsIds:{
  active:false,
  weight:0,
  params:{
    is:false,
    intCount:3,
    intersectMin:3,
  },
},
},
]

},

}
},

methods:{

},

mounted (){
},

}
</script>

<style>
 .row-selected {
   background-color: red
 }
</style>
